document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id$="__trust"] .multicolumn-list').forEach((list) => {
    Array.from(list.children).forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, input').forEach((el) => el.setAttribute('tabindex', '-1'));
      list.appendChild(clone);
    });
  });
});
